import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash.isempty';
import {
  BUY_FOR_STORAGE_WIZARD,
  WIZARD_DATA,
} from '../../constants/sessionStorage';
import StepByStep from '../StepByStep';
import OrderSelection from './OrderSelection';
import OrderReview from './OrderReview';
import OrderConfirmation from './OrderConfirmation';
// import Status from '../Modals/Status';
import {
  selectBuyError,
  selectIsBuyStorageSuccessful,
  selectStorageProduct,
} from '../../store/selectors/buyStorageSelectors';
import Paragraph from '../Paragraph/Paragraph';
import {
  removeFromSessionStorage,
  retrieveFromSessionStorage,
  storeInSessionStorage,
} from '../../util/helpers/sessionStorageHelper';
import BasicModal from '../BasicModal/BasicModal';

const BuyFlowSteps = [
  { children: OrderSelection },
  { children: OrderReview },
  { children: OrderConfirmation },
];

const BuyFlow = ({
  handleCloseModal,
  isModalOpen,
  // setWizardData,
  // wizardData,
  handleBack,
  handleNext,
  handleCloseModalOnBuy,
  setWizardTitle,
  // setCloseIconVisible,
  isProductPage,
  skipChooseLocation,
  isSegregated,
  tiers,
  counter,
  unity,
  isPostPaidVisible,
}) => {
  const { t } = useTranslation();
  const isBuyStorageSuccessful = useSelector(selectIsBuyStorageSuccessful);
  const errorMessage = useSelector(selectBuyError);
  const storageProduct = useSelector(selectStorageProduct);
  const [wizardData, setWizardData] = useState(
    () => retrieveFromSessionStorage(WIZARD_DATA) || {},
  );

  useEffect(() => {
    if (isBuyStorageSuccessful || errorMessage) {
      setWizardData({
        ...wizardData,
        isBuyStorageSuccessful: !isBuyStorageSuccessful,
        errorMessage,
        isSegregated,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBuyStorageSuccessful, errorMessage]);

  const setDataForWizard = (value) => {
    setWizardData((prev) => ({ ...prev, ...value }));
    storeInSessionStorage(WIZARD_DATA, { ...wizardData, ...value });
  };

  useEffect(() => {
    if (isEmpty(wizardData?.storageProduct)) {
      setDataForWizard({ storageProduct });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageProduct]);

  const closeModal = () => {
    handleCloseModal();
    removeFromSessionStorage(WIZARD_DATA);
    // removeFromSessionStorage(STATUS_NEW_ADDRESS_ADDED);
    // removeFromSessionStorage(SIGNIFYD_SESSION_ID);
  };

  return (
    <BasicModal
      title="Buy"
      size="lg"
      isOpen={isModalOpen}
      close={closeModal}
      closeIconVisible
    >
      <StepByStep sessionScopeStep={BUY_FOR_STORAGE_WIZARD}>
        {({ goStepForward, goStepBack, skipPreviousStep }) =>
          BuyFlowSteps.map((buyStorageStep) =>
            React.createElement(buyStorageStep.children, {
              handleBack: goStepBack,
              handleNext: goStepForward,
              skipPreviousStep,
              closeModal,
              setWizardData: setDataForWizard,
              wizardData,
              handleBuyWizardBack: handleBack,
              handleBuyWizardNext: handleNext,
              handleCloseModalOnBuy,
              hasError: wizardData?.isBuyStorageSuccessful,
              text: wizardData?.errorMessage || (
                <>
                  <Paragraph centerText>
                    {t('buyWizard.confirmationMessage.orderPlaced')}
                  </Paragraph>
                  <Paragraph centerText>
                    {t('buyWizard.confirmationMessage.onTradeConfirmedMessage')}
                  </Paragraph>
                </>
              ),
              onButtonClick: closeModal,
              setWizardTitle,
              // setCloseIconVisible,
              isProductPage,
              skipChooseLocation,
              tiers,
              counter,
              unity,
              isSegregated,
              isPostPaidVisible,
            }),
          )
        }
      </StepByStep>
    </BasicModal>
  );
};

BuyFlow.propTypes = {
  handleCloseModal: PropTypes.func,
  // setWizardData: PropTypes.func,
  wizardData: PropTypes.shape({
    isBuyStorageSuccessful: PropTypes.bool,
    errorMessage: PropTypes.string,
    isSegregated: PropTypes.bool,
  }),
  handleBack: PropTypes.func,
  handleNext: PropTypes.func,
  setWizardTitle: PropTypes.func,
  // setCloseIconVisible: PropTypes.func,
  isProductPage: PropTypes.bool,
  skipChooseLocation: PropTypes.bool,
  isSegregated: PropTypes.bool,
  handleCloseModalOnBuy: PropTypes.func,
  tiers: PropTypes.shape({
    HighBound: PropTypes.number,
    LowBound: PropTypes.number,
    PricePerOz: PropTypes.number,
    PricePerUnit: PropTypes.number,
  }),
  counter: PropTypes.number,
  unity: PropTypes.bool,
  isPostPaidVisible: PropTypes.bool,
  isModalOpen: PropTypes.bool,
};

export default BuyFlow;
